import type MapProperty from '../private/IMapProperty';

/**
 * @description array of each field & how to convert between external(api) & internal representations
 */
const MAPPINGS: MapProperty[] = [
    {
        localName: 'id',

        defaultValue: 0,
    },
    {
        localName: 'name',

        defaultValue: '',
    },
    {
        localName: 'logoFileName',

        defaultValue: '',
    },
    {
        localName: 'removeLogo',

        defaultValue: false,
    },
    {
        localName: 'logoMediumId',

        defaultValue: '',
    },
    {
        localName: 'alarmEnabled',

        defaultValue: false,
    },
    {
        localName: 'alarmPin',

        defaultValue: '',
    },
    {
        localName: 'adminPin',

        defaultValue: '',
    },
    {
        localName: 'languageSelectionMenu',

        defaultValue: 0,
    },
    {
        localName: 'tourSelectionMenu',

        defaultValue: 0,
    },
    {
        localName: 'clientId',

        defaultValue: 0,
    },
    {
        localName: 'screenOrientationId',

        defaultValue: 0,
    },
    {
        localName: 'majorVersion',

        defaultValue: 0,
    },
    {
        localName: 'minorVersion',

        defaultValue: 0,
    },
    {
        localName: 'toursCount',

        defaultValue: 0,
    },
    {
        localName: 'deviceAccountsCount',

        defaultValue: 0,
    },
    {
        localName: 'languageSelectionStyleId',

        defaultValue: 0,
    },
    {
        localName: 'tourSelectionStyleId',

        defaultValue: 0,
    },
    {
        localName: 'groupingSelectionMenu',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'screenOrientations',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'contactName',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'title',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'phone',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'mobile',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'addressLine1',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'addressLine2',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'county',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'postalCode',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'countryId',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'notes',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'bluetoothEnabled',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'streamMedia',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'streamingMediaPrefixUrl',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'showBatteryDot',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'disableSpeakerOutput',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'grayOutContentOnPlayback',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'backButtonStyleId',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'batteryThresholdRed',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'batteryThresholdOrange',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'screensaverEnabled',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'screensaverShowDelay',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'resetInactivityDelay',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'alwaysShowLanguageSelection',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'alwaysShowTourSelection',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'alwaysShowGroupingSelection',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'showGroupingSelectionHeader',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'showLanguageSelectionHeader',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'showTourSelectionHeader',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'showLanguageConfirmation',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'resetGroupingDaily',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'groupingMenuEnabled',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'groupingShow',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'groupingSelectionStyleId',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'defaultLanguageId',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'groupingHeader',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'languageHeader',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'tourHeader',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'siteObjectOnGroupingSelectionId',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'siteObjectOnGroupingSelectionInitName',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'siteObjectOnLanguageSelectionId',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'siteObjectOnLanguageSelectionInitName',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'siteObjectOnTourSelectionId',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'siteObjectOnTourSelectionInitName',

        defaultValue: '',
        optional: true,
    },
];

export default MAPPINGS;
